import { getCurrentLiveViewSnapshot } from '../api/requests'
import { useLiveViewStateStore } from '../LiveViewStore'

const useLiveViewScreenshot = () => {
    const { baseURL } = useLiveViewStateStore()
    const getScreenshot = async () => {
        let imageURL = ''
        try {
            const response = await getCurrentLiveViewSnapshot(baseURL)
            const blob = new Blob([response.data], { type: 'image/jpeg' })
            const localImageURL = URL.createObjectURL(blob)
            imageURL = localImageURL
        } catch (error) {
            console.error('Error downloading image:', error)
        }
        return imageURL
    }
    return { getScreenshot }
}
export default useLiveViewScreenshot
